const IconDashboard: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    focusable='false'
    role='presentation'
    fill='currentColor'
    {...props}
    className={`icon icon-dashboard${props.className ? ' ' + props.className : ''}`}
  >
    <path fill='none' d='M0 0h24v24H0z'></path>
    <path d='M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z'></path>
  </svg>
);
export default IconDashboard;
